import moment from "moment";
import Swal from "sweetalert2";

export const urlToBlob = async (url) => {
    // Fetch the image data from the URL
    const response = await fetch(url);

    // Convert the fetched image data to Blob
    const blob = await response.blob();

    return blob;
}

export const redirectTo = async (path) => {
  const prefixpath = process.env.REACT_APP_NODE_ENV == 'prod' ? '' : '/backoffice' 
  window.location.href = prefixpath + path;
}

export const getCurrentPrefixPathFromEnv = async () => {
  return process.env.REACT_APP_NODE_ENV == 'prod' ? '/' : '/backoffice' 
}

export const alertValidate = async (title) => {
    const res = await Swal.fire({
        iconHtml: '<img src="https://img2.pic.in.th/pic/Group-2966.png">',
        title: title,
    });
    if (res.isConfirmed) {
      return;
    } else {
      return;
    }
}

export const isValidHttpUrl = (string) => {
    const url = decodeURIComponent(string);
    const regex = /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost)(:[0-9]{1,5})?(\/[^\s]*)?$/;
    return regex.test(url);
  }

  
export const getMinDateFromStart = (dateStr ) => {
    const parseDate = moment(dateStr, 'DD/MM/YYYY')
    if(parseDate.isValid()){

        return new Date(parseDate)
    }

    return  new Date()
    
}



export const isDateRangeCorrect = (dateStart, dateEnd) => {
  return moment(dateEnd).diff(dateStart, 'day') >= 0
}